import Upload from 'helpers/Upload.ts'
import Funcs from 'helpers/Functions.ts'

export const buffer2Base64 = (
	arrayBuffer: ArrayBuffer,
	mimetype = 'image/jpeg'
) => {
	if (typeof arrayBuffer === 'undefined' || arrayBuffer.byteLength === 0) {
		return undefined
	}
	return (
		'data:' + mimetype + ';base64,' + bytesToBase64(new Uint8Array(arrayBuffer))
	)
}

/**
 * Base64 in 32-KB-Blöcken. Die frühere Byte-für-Byte-String-Verkettung war quadratisch
 * und blockierte bei einem Profilfoto von einigen MB den Main-Thread für ~5 s.
 */
export const bytesToBase64 = (bytes: Uint8Array): string => {
	let binary = ''
	for (let i = 0; i < bytes.length; i += 0x8000) {
		binary += String.fromCharCode(...bytes.subarray(i, i + 0x8000))
	}
	return btoa(binary)
}

const Func = { ...Funcs, ...Upload }

export default Func
